import { Controller, Get, Render } from '@nestjs/common';
import { AppService } from './app.service';
import { Public } from '@/common/decorators/public.decorator';

@Controller()
export class AppController {
  constructor(private readonly appService: AppService) {}

  @Get()
  @Public()
  @Render('index.hbs')
  root() {
    return { appName: process.env.APP_NAME };
  }
}
